import {Button, Flex} from '@chakra-ui/react';
import {colors} from 'components/providers';
import {useDesktop} from 'hooks';
import React, {FC} from 'react';

import {IconArrow} from './components';

interface Props {
  variant: 'left' | 'right';
  onClick?: () => void;
  right?: string;
  left?: string;
}

export const SliderArrow: FC<Props> = React.memo(({variant, onClick, right, left}) => {
  const isDesktop = useDesktop();
  if (!isDesktop) return null;
  return (
    <Button
      display={onClick ? 'block' : 'none'}
      disabled={!onClick}
      w={['30px', '46px']}
      h={['40px', '46px']}
      sx={{
        borderRadius: '50%',
        boxShadow: '0px 3px 10px rgba(0, 0, 0, 0.25)',
        position: 'absolute',
        zIndex: '99',
        bg: colors.white,
        top: 'calc(50% - 25px)',
        p: 0,
      }}
      right={variant === 'right' && !right ? '30px' : right}
      left={variant === 'left' && !left ? '30px' : left}
      onClick={onClick}
      className={`slider-arrow slider-arrow-${variant}`}
      _focus={{border: 'none'}}
      _hover={{
        bg: colors.pink,
        color: colors.white,
        '.icon svg path': {
          fill: 'white',
        },
      }}
      aria-label="Slider Arrow"
    >
      <Flex
        className="icon"
        justifyContent="center"
        alignItems="center"
        transform={`rotate(${variant === 'left' ? '180deg' : 0})`}
      >
        <IconArrow />
      </Flex>
    </Button>
  );
});
